import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
    {
      question: "My experience with relevant programming languages and technologies?",
      answer:
        "I have extensive experience with Java, Typescript and JavaScript, along with proficiency in various web development frameworks such as Angular, Next.js and React. My background also includes working with databases like MongoDB, PostgreSQL and NoSQL solutions. I've used these technologies to developweb applications and APIs for the past 3 years.",
    },
    {
      question: "My experience with collaborative development tools and methodologies?",
      answer:
        "I'm well-versed in collaborative tools like Git for version control and have experience with Agile methodologies, particularly Scrum. In my previous role, I worked in cross-functional teams, participating in daily stand-ups, sprint planning, and retrospective meetings. This allowed us to maintain clear communication and deliver high-quality software on schedule.",
    },
    {
      question: "What is my strength being a programmer?",
      answer:
        "Among my strengths, I consider myself a strong team player, valuing collaboration and diverse perspectives. I'm also a quick learner, adapting to new technologies efficiently, and I'm always eager to embrace new challenges and expand my knowledge. My willingness to learn new tech makes me versatile and adaptable.",
    },
    {
      question: "What motivated me to become a programmer in the first place?",
      answer:
        "I've always been drawn to problem-solving and creating solutions. Programming allows me to combine my logical thinking with my creativity. It's a field where I can continuously learn and adapt, which excites me.",
    },
    {
      question: "What is my future goal as a programmer?",
      answer:
        "My future goal as a programmer is to continue growing and evolving in my career. I aim to become an expert in specific areas of programming, such as machine learning or cybersecurity, where I can contribute to cutting-edge projects and make a significant impact. Additionally, I want to take on more leadership responsibilities and potentially lead development teams. Ultimately, I aspire to inspire and mentor the next generation of programmers, sharing my knowledge and experiences to help others achieve their goals in the field.",
    },
  ];

  return (
    <section id="faq" className="section bg-light">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            {/* Heading */}
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">FAQ</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Have any questions?
            </h2>
            {/* Heading end*/}

            <Accordion flush defaultActiveKey="0">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            {" "}
            <img
              className="img-fluid"
              src="images/faq.png"
              title="FAQ"
              alt="faq"
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
